import { render, staticRenderFns } from "./pinglun.vue?vue&type=template&id=06cec200&scoped=true"
import script from "./pinglun.vue?vue&type=script&lang=js"
export * from "./pinglun.vue?vue&type=script&lang=js"
import style0 from "./pinglun.vue?vue&type=style&index=0&id=06cec200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cec200",
  null
  
)

export default component.exports